'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002eeventbus$002e$002dEvent$002dBus$002dStream from "./com.raquo.airstream.eventbus.-Event-Bus-Stream.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d from "./scala.scalajs.runtime.-Anon-Function0.$$-Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_eventbus_WriteBus(parentDisplayName, displayNameSuffix) {
  this.Ec = null;
  this.Ed = null;
  this.Eb = null;
  this.lv = null;
  this.Ed = parentDisplayName;
  this.Eb = displayNameSuffix;
  this.Ec = (void 0);
  this.lv = new $j_com$002eraquo$002eairstream$002eeventbus$002e$002dEvent$002dBus$002dStream.$c_Lcom_raquo_airstream_eventbus_EventBusStream(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this))));
}
export { $c_Lcom_raquo_airstream_eventbus_WriteBus as $c_Lcom_raquo_airstream_eventbus_WriteBus };
$p = $c_Lcom_raquo_airstream_eventbus_WriteBus.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_eventbus_WriteBus;
/** @constructor */
function $h_Lcom_raquo_airstream_eventbus_WriteBus() {
}
export { $h_Lcom_raquo_airstream_eventbus_WriteBus as $h_Lcom_raquo_airstream_eventbus_WriteBus };
$h_Lcom_raquo_airstream_eventbus_WriteBus.prototype = $p;
$p.dP = (function() {
  return this.Ec;
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.lh = (function() {
  return this;
});
$p.cW = (function(nextValue) {
  if ($j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this.lv)) {
    this.lv.fW(nextValue, null);
  }
});
$p.l6 = (function(nextError) {
  if ($j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this.lv)) {
    this.lv.fV(nextError, null);
  }
});
$p.fY = (function(nextValue) {
  nextValue.eT(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextError) => {
    this.l6(nextError);
  })), new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextValue$2) => {
    this.cW(nextValue$2);
  })));
});
$p.dd = (function() {
  return (("" + this.Ed.h()) + this.Eb);
});
var $d_Lcom_raquo_airstream_eventbus_WriteBus = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_eventbus_WriteBus, "com.raquo.airstream.eventbus.WriteBus", ({
  gY: 1,
  aP: 1,
  M: 1,
  bH: 1
}));
export { $d_Lcom_raquo_airstream_eventbus_WriteBus as $d_Lcom_raquo_airstream_eventbus_WriteBus };
